module.exports = __webpack_public_path__ + "static/media/Item_02.ee515b13.png";